import DraggablePartListView from './DraggablePartListView'

export default DraggablePartListView
